import React, { useContext, FunctionComponent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Custom Components
import DynamicDialog from '@/ui/Dialog/DynamicDialog';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogActionButtonClose from '@/ui/Dialog/ActionButtons/DialogActionButtonClose';
import DialogContext, { IDialogProps } from '@/context/DialogContext/DialogContext';

// Types
import { ClosingDetails } from '@/@types/components/formController';
import { DCRecord } from '@/@types/lib/dataController';
import DataController from '@/lib/DataController';
import ModelTable from '../Table/ModelTable';

const GeneralTableDialog: FunctionComponent<IDialogProps> = (props) => {
  const { hideDialog } = useContext(DialogContext);

  const { dc, view, onClose, title, level, customPath, tableId } = props;

  const [records, setRecords] = useState<DCRecord[]>([]);

  const { t } = useTranslation();

  useEffect(() => {
    (dc as DataController).GetData(customPath).then((resp) => {
      if (resp.success) {
        setRecords(resp.data as DCRecord[]);
      }
    });
  }, []);

  const handleClose = () => {
    close({ dataChanged: false, action: 'cancel' });
  };

  const close = (result: ClosingDetails) => {
    onClose(result);
    hideDialog(level);
  };


  /* const handleRowStyle: (id: number) => BackgroundColorObj | {} = (id: number) => {
    const record = historyRecords.find((rec) => rec.id === id);
    if (record?.is_newest) {
      return { backgroundColor: `${theme.palette.success.light}50` };
    }
    return {};
  }; */

  return (
    <DynamicDialog open maxWidth="xl" onClose={handleClose}>
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>{t(title)}</DialogToolbarHeading>
          <ToolbarFillContent />

          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent>
        <ModelTable
          identifier={tableId}
          allowRowAction={() => false}
          onRowAction={() => {}}
          dc={dc}
          title={title}
          records={records}
          size="small"
          allowExport
          allowFilter
          allowColumnPicker
          viewName={view}
          allowSelection="none"
          disableControls={false}
          // getRowStyle={handleRowStyle}
        />
      </DialogContent>
      <DialogActions>
        <DialogActionButtonClose variant="outlined" onClick={handleClose} />
        {/* mode === 'insert' ? (
          <DialogActionButtonAdd variant="contained" onClick={handleInsert} />
        ) : mode === 'update' ? (
          <DialogActionButtonSave variant="contained" onClick={handleUpdate} />
        ) : null */}
      </DialogActions>
    </DynamicDialog>
  );
};

export default GeneralTableDialog;
